export const zIndex = {
    header: 100,
    tooltip: 110,
    shroud: 50
};
//# sourceMappingURL=z-index.js.map